import { useSubscribeToEliteMutation } from '../../hooks/useSubscribeElite'
import { usePeerAnalyserStore } from '../../state-management/peerAnalyserStore'
import Button from '../ui-components/Button'
import BottomSheetContent from './BottomSheetContent'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'

export default function UnlockEliteBottomSheet({ onDismiss, fundCategory, tenureInDays }: any) {
  const subscribeToElite = useSubscribeToEliteMutation()
  const selectedCategoryId = usePeerAnalyserStore((state) => state.selectedCategoryId)
  const setShowEliteUnlockedModal = usePeerAnalyserStore((state) => state.setShowEliteUnlockedModal)

  // Define the onClick handler as a separate function within the component body
  const handleUnlockClick = () => {
    // Track Unlock Elite click
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: 'PeerAnalyser_BottomSheet_UnlockOffer',
        buttonLabel: 'Unlock Elite',
        eventId: selectedCategoryId
      }
    })
    subscribeToElite.mutate(
      { fundCategory: selectedCategoryId },
      {
        onSuccess: () => {
          // Small delay before showing modal for smoother transition
          setTimeout(() => {
            onDismiss()
            setShowEliteUnlockedModal(true)
            // Hide the modal after showing it for 2.5 seconds
            setTimeout(() => {
              setShowEliteUnlockedModal(false)
            }, 2500)
          }, 150)
        }
      }
    )
  }

  const handleGoBackClick = () => {
    // Track Go Back click
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: 'PeerAnalyser_BottomSheet_UnlockOffer',
        buttonLabel: 'Go Back',
        eventId: selectedCategoryId
      }
    })
    onDismiss()
  }

  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      bgWhiteRequired={false}
      bottomSheetClassName='bg-gradient-to-b from-[#FEF7EB] to-white'
      bottomSheetCtas={
        <div className='flex flex-col gap-4'>
          <Button
            buttonClassName='bg-black text-white h-[56px] text-[16px]'
            isFullWidth
            onClick={handleUnlockClick} // Reference the defined handler
          >
            {subscribeToElite.isPending ? 'Unlocking...' : `Unlock for ${fundCategory}`}
          </Button>
          <Button buttonClassName='py-4 h-[56px] text-[16px]' isFullWidth onClick={handleGoBackClick}>
            Go back
          </Button>
        </div>
      }
    >
      <div>
        <div>
          {/* Ensure your image path is correct, use /elite_badge.png if it's in public folder */}
          <img src='/elite_badge.png' className='h-20 w-20' alt='Elite Badge' />
        </div>
        <div>
          <p className='mt-4 text-[15px] font-medium text-[#CC5C2D]'>Power Select Trial Offer</p>
        </div>
        <div className='text-[22px] font-medium mb-4 leading-[30.8px]'>
          Get free access to Elite insights in any one category
        </div>
        <p className='text-sm text-grey40'>
          Compare and select funds like an expert, with Elite insights at your fingertips. Offer valid for:
          <br />
          <br />
          <ul className='list-disc list-inside'>
            <li>
              {tenureInDays} {tenureInDays > 1 ? 'days' : 'day'}
            </li>
            <li>Power Select only</li>
          </ul>
        </p>
      </div>
    </BottomSheetContent>
  )
}
